<div class="component-container flex flex-col gap-[40px]">
  <div
    class="action-section mt-[40px] flex flex-row justify-end gap-[20px]"
    >
    <div
      #trigger="cdkOverlayOrigin"
      (click)="isOpen = true" cdkOverlayOrigin class="change-order-filter-button flex flex-row gap-[20px]"
      type="button"
      >
      <div class="label text-type-7 flex flex-row justify-between items-center">
        <div
          class="pick-list-value"
          #selectedSpan
          [matTooltip]="selectedValue['order_number']"
          [matTooltipDisabled]="!isEllipsisActive(selectedSpan)"
          matTooltipPosition="above"
          matTooltipClass="co-filter-tooltip white-tooltip"
          >
          {{ selectedValue['order_number'] }}
        </div>
        @if (selectedValue.created_at) {
          <div
            class="current ml-[5px] text-[#60698B]"
            >
            ({{ selectedValue['created_at'] | date :'mediumDate' }})
          </div>
        }
      </div>
      <mat-icon
        [ngClass]="{'rotate': isOpen}"
        class="dropdown-icon"
        svgIcon="chevron-down"
        />
    </div>
    <ng-template
      (backdropClick)="isOpen = false"
      [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayOpen]="isOpen"
      [cdkConnectedOverlayOrigin]="trigger"
      cdkConnectedOverlay
      >
      <div class="change-order-filter-popup">
        <div class="change-order-filter-list">
          @for (eachChangeOrder of changeOrderFilter; track eachChangeOrder; let i = $index) {
            <div
              (click)="changeOrderFilterItemClicked(eachChangeOrder)"
              class="change-order-filter-item"
              >
              <div class="flex flex-col justify-center">
                @if (eachChangeOrder['order_number']) {
                  <div
                    [ngClass]="{'selected-filter-option': selectedValue.id === eachChangeOrder.id}"
                    class="pick-list-option-value text-type-11"
                    #optionSpan
                    [matTooltip]="eachChangeOrder['order_number']"
                    [matTooltipDisabled]="!isEllipsisActive(optionSpan)"
                    matTooltipPosition="above"
                    matTooltipClass="co-filter-tooltip white-tooltip"
                    >
                    {{ eachChangeOrder['order_number'] }}
                  </div>
                }
                @if (eachChangeOrder['id'] !== -1) {
                  <div class="text-type-10">
                    ({{ eachChangeOrder['created_at'] | date :'mediumDate' }})
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>
    <div>
      @if (selectedSortColumn) {
        <mat-form-field class="sort-dropdown">
          <mat-select
            (selectionChange)="onSortColumnChange($event)"
            [(value)]="selectedSortColumn"
            disableOptionCentering
            panelClass="rfi-sort-panel"
            >
            <mat-select-trigger>
              {{ selectedSortColumn ? 'Sort by: ' + selectedSortColumn : 'Sort: ' }}
            </mat-select-trigger>
            @for (column of sortByColumns; track column) {
              <mat-option [value]="column">
                {{ column | titlecase }}
              </mat-option>
            }
          </mat-select>
          <mat-icon (click)="removeSort($event)" class="sort-close" matSuffix>close</mat-icon>
        </mat-form-field>
      }
      @if (!selectedSortColumn) {
        <div (click)="openSortDropdown($event)" class="sort-dropdown nosort">
          <div class="label text-type-8">Sort:</div>
          <mat-icon>sync_alt</mat-icon>
          <mat-form-field class="sr-sort-hidden">
            <mat-select
              #sortSelect
              (selectionChange)="onSortColumnChange($event)"
              [(value)]="selectedSortColumn"
              disableOptionCentering
              panelClass="rfi-sort-panel"
              >
              @for (column of sortByColumns; track column) {
                <mat-option [value]="column">
                  {{ column | titlecase }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
    <form [formGroup]="form" class="search-section flex-1 min-w-0">
      <div class="search w-full">
        <mat-icon svgIcon="search"></mat-icon>
        <input
          class="search-input"
          data-testid="bid-sheet-search"
          formControlName="searchText"
          matInput
          placeholder="Search by item no or description"
        />
        @if (form.controls.searchText.value) {
          <mat-icon (click)="clearSearch()" class="cursor-pointer" svgIcon="close"></mat-icon>
        }
      </div>
    </form>
    @if (bidSheetId) {
      <div class="download-button-container">
        @if (downloadingCsv) {
          <mat-spinner color="primary" diameter="24" mode="indeterminate" strokeWidth="3"></mat-spinner>
        } @else {
          <button
            (click)="downloadCsv()"
            class="download-button"
            data-testid="bid-sheet-download-csv"
            mat-icon-button
            matTooltip="Download bid sheet (CSV)"
            matTooltipClass="white-tooltip"
          >
            <mat-icon>download</mat-icon>
          </button>
        }
      </div>
    }
    @if (dataSource?.length && changeOrderMode === 'direct') {
      <button
        (click)="onUploadChangesClicked()"
        class="upload-btn"
        color="primary"
        mat-stroked-button
        >
        Upload changes
      </button>
    }
  </div>
  @if (dataSource?.length) {
    <div class="bit-items-table">
      <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
        <!-- Item Column -->
        <ng-container matColumnDef="item">
          <th *matHeaderCellDef class="text-type-5" mat-header-cell> Item</th>
          <td *matCellDef="let row" mat-cell>
            <div class="text-type-8">{{ row.item }}</div>
            <div
            [class.highlight]="row?.previous_value
                               && row?.previous_value[0]?.description
                               && row?.previous_value[0]?.description !== row?.description"
              class="description text-type-14"
              >
              {{ row.description }}
            </div>
          </td>
        </ng-container>
        <!-- Quantity Column -->
        <ng-container matColumnDef="quantity">
          <th *matHeaderCellDef class="text-type-5" mat-header-cell> Quantity</th>
          <td *matCellDef="let row" class="text-type-10" mat-cell>
            <div class="quantity">
              <div
              [class.highlight]="(row?.previous_value
                                && row?.previous_value[0]?.quantity
                                && (row?.previous_value[0]?.quantity !== row?.quantity))
                                || hasSiteQuantityChanges(row)"
                >
                {{ row?.quantity }}
              </div>
              @if (row?.previous_value
                && row?.previous_value[0]?.quantity
                && (row?.previous_value[0]?.quantity !== row?.quantity)) {
                <div
                  class="previous-value text-type-14">
                  from {{ row?.previous_value[0]?.quantity }}
                </div>
              }
            </div>
          </td>
        </ng-container>
        <!-- CO Qty Column (Current view only) -->
        <ng-container matColumnDef="coQty">
          <th *matHeaderCellDef class="text-type-5" mat-header-cell> CO Qty</th>
          <td *matCellDef="let row" class="text-type-10" mat-cell>
            {{ row?.change_order_qty || '' }}
          </td>
        </ng-container>
        <!-- Unit Price Column -->
        <ng-container matColumnDef="unitPrice">
          <th *matHeaderCellDef class="text-type-5" mat-header-cell> Unit price</th>
          <td *matCellDef="let row" class="text-type-10" mat-cell>
            <div class="unit-price">
              <div
              [class.highlight]="row?.previous_value
                                 && row?.previous_value[0]?.unit_price
                                 && row?.previous_value[0]?.unit_price !== row?.unit_price"
                >
                {{ row?.unit_price }}
              </div>
              @if (row?.previous_value
                && row?.previous_value[0]?.unit_price
                && row?.previous_value[0]?.unit_price !== row?.unit_price) {
                <div
                  class="previous-value text-type-14">
                  from {{ row?.previous_value[0]?.unit_price }}
                </div>
              }
            </div>
          </td>
        </ng-container>
        <!-- UOM Column -->
        <ng-container matColumnDef="uom">
          <th *matHeaderCellDef class="text-type-5" mat-header-cell> UOM</th>
          <td *matCellDef="let row" class="text-type-10" mat-cell>
            <div class="uom">
              <div
              [class.highlight]="row?.previous_value
                                 && row?.previous_value[0]?.uom
                                 && row?.previous_value[0]?.uom !== row?.uom"
                >
                {{ row.uom }}
              </div>
              @if (row?.previous_value
                && row?.previous_value[0]?.uom
                && row?.previous_value[0]?.uom !== row?.uom) {
                <div
                  class="previous-value text-type-14">
                  from {{ row?.previous_value[0]?.uom }}
                </div>
              }
            </div>
          </td>
        </ng-container>
        <!-- Header and Row Definitions -->
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr (click)="rowClicked(row)"
          *matRowDef="let row; columns: displayedColumns;"
          [class.highlighted-row]="row === selectedRow"
        mat-row></tr>
      </table>
    </div>
  }
  @if (!dataSource?.length && searchTerm) {
    <div class="no-data text-type-8 mt-[80px]">No bid items match your search.</div>
  }
  @if (!dataSource?.length && !searchTerm) {
    <div class="no-data text-type-8 mt-[80px]">
      You dont have any bid item yet. Use this <span class="clickable">template</span> to import your data.
    </div>
    <app-primary-button
      (handleClick)="import('fileUploadRef')"
      class="import-btn w-[200px]"
      >
      Import
    </app-primary-button>
    <input
      #fileUploadRef
      (change)="handleFileUpload()"
      [id]="'fileUploadRef'"
      class="input-files"
      type="file"
      />
  }
  <app-paginator
    (pageChanged)="onPageChanged($event)"
    [itemsPerPage]="pagination.pageSize"
    [totalItems]="totalRecords"
    class="paginator"
    >
  </app-paginator>
</div>


